/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type LogConsentDataContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AccountContainer_user$ref: FragmentReference;
export type AccountContainer_user = {|
  +id: string,
  +email: ?string,
  +username: ?string,
  +$fragmentRefs: LogConsentDataContainer_user$ref,
  +$refType: AccountContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "AccountContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "username",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "LogConsentDataContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9fa403edf6ae91c333f625b09a99e561';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Account/__generated__/AccountContainer_user.graphql.js